import { useAuth } from '../../../hooks/useAuth';

const useProfile = () => {
    const { userProfile, isPending } = useAuth();

    return {
        userProfile,
        loading: isPending,
    };
};

export { useProfile };
